import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const WhyTraainFranchise = () => {
  const improvements = [
    'Frontline communication and professionalism',
    'Customer experience delivery',
    'Product and service knowledge',
    'Onboarding speed and readiness',
    'Manager coaching efficiency',
    'Field-level performance visibility',
    'Multi-location consistency',
    'Brand reputation and customer loyalty'
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">
            One Route. One Standard.
          </h2>
          <p className="text-2xl text-cyan-400 font-semibold mb-6">
            Every Location, Every Role, Every Shift.
          </p>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto">
            Traain helps franchise brands standardize excellence across locations using intelligent training, realistic practice, and measurable performance insights.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <p className="text-xl font-bold text-white mb-6 text-center">With Traain, brands can improve:</p>
          <div className="grid md:grid-cols-2 gap-4">
            {improvements.map((improvement, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-5 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 transition-all duration-300"
              >
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <p className="text-gray-300">{improvement}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <div className="inline-block p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-xl text-white font-semibold">
              Traain turns frontline teams into confident, consistent performers — even in high-turnover environments.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyTraainFranchise;
